import {Component, Input} from '@angular/core';
import {NgClassType} from "../../model/common.model";
import {NgClass, NgIf} from "@angular/common";
import {MatButtonModule} from "@angular/material/button";
import {RouterLink} from "@angular/router";
import {MatIconModule} from "@angular/material/icon";

@Component({
  selector: 'delete-button',
  standalone: true,
  imports: [
    NgIf,
    MatButtonModule,
    NgClass,
    RouterLink,
    MatIconModule
  ],
  templateUrl: './delete-button.component.html',
})
export class DeleteButtonComponent {
  @Input() routerLink: any[] | string | null | undefined = ['delete']
  @Input() ngClass: NgClassType
  @Input() useLinkButton = false
  @Input() disabled = false
}
